import { render, staticRenderFns } from "./ColumnStats.vue?vue&type=template&id=d15ae22c&"
import script from "./ColumnStats.vue?vue&type=script&lang=js&"
export * from "./ColumnStats.vue?vue&type=script&lang=js&"
import style0 from "./ColumnStats.vue?vue&type=style&index=0&id=d15ae22c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports